import React, {
  useEffect,
  useState,
} from "react";

import {
  FaArrowDown,
  FaBirthdayCake,
  FaCalendarAlt,
  FaWeight,
} from "react-icons/fa";

import CateButton from "../ui/CateButton";

const HERO_IMAGES = [
  "/images/fond14.webp",
  "/images/fond15.webp",
];

export default function CateHero({
  season,
  onStart,
}) {
  const [activeImage, setActiveImage] =
    useState(0);

  useEffect(() => {
    const interval = window.setInterval(
      () => {
        setActiveImage(
          (current) =>
            (current + 1) %
            HERO_IMAGES.length
        );
      },
      7000
    );

    return () => {
      window.clearInterval(interval);
    };
  }, []);

  return (
    <section className="relative isolate min-h-[620px] overflow-hidden bg-slate-950">
      {HERO_IMAGES.map(
        (image, index) => (
          <div
            key={image}
            className={[
              "absolute inset-0 bg-cover bg-center transition-opacity duration-1000",
              index === activeImage
                ? "opacity-100"
                : "opacity-0",
            ].join(" ")}
            style={{
              backgroundImage: `url("${image}")`,
            }}
          />
        )
      )}

      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(2,6,23,0.97)_0%,rgba(2,6,23,0.84)_48%,rgba(2,6,23,0.38)_100%)]" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-slate-950/30" />

      <div className="absolute -left-24 top-24 h-72 w-72 rounded-full bg-orange-500/20 blur-3xl" />
      <div className="absolute -right-20 bottom-10 h-80 w-80 rounded-full bg-amber-300/10 blur-3xl" />

      <div className="relative mx-auto flex min-h-[620px] max-w-7xl items-center px-4 py-24 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-amber-300 backdrop-blur">
            <FaCalendarAlt />
            Saison {season}
          </div>

          <h1 className="mt-6 text-5xl font-black leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-8xl">
            Mon
            <span className="bg-gradient-to-r from-amber-300 via-orange-400 to-red-500 bg-clip-text text-transparent">
              Appli
            </span>
            Caté
          </h1>

          <p className="mt-7 max-w-2xl text-lg leading-relaxed text-slate-200 sm:text-xl">
            Découvrez rapidement votre
            catégorie d’âge, votre catégorie
            de poids et, le cas échéant, votre
            classe vétéran.
          </p>

          <CateButton
            icon={FaArrowDown}
            className="mt-8"
            onClick={onStart}
          >
            Calculer ma catégorie
          </CateButton>

          <div className="mt-10 grid max-w-2xl gap-3 sm:grid-cols-3">
            <HeroItem
              icon={FaBirthdayCake}
              title="Catégorie d’âge"
              text="Selon votre année de naissance"
            />

            <HeroItem
              icon={FaWeight}
              title="Catégorie de poids"
              text="Selon votre âge et votre genre"
            />

            <HeroItem
              icon={FaCalendarAlt}
              title="Saison sportive"
              text="Du 1er août au 31 juillet"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-slate-50 to-transparent dark:from-slate-950" />
    </section>
  );
}

function HeroItem({
  icon: Icon,
  title,
  text,
}) {
  return (
    <article className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
      <Icon className="text-xl text-amber-300" />

      <p className="mt-3 text-sm font-black text-white">
        {title}
      </p>

      <p className="mt-1 text-xs leading-5 text-slate-300">
        {text}
      </p>
    </article>
  );
}